import { render, staticRenderFns } from "./feed-item.vue?vue&type=template&id=1c52a811&scoped=true&"
import script from "./feed-item.vue?vue&type=script&lang=js&"
export * from "./feed-item.vue?vue&type=script&lang=js&"
import style0 from "./feed-item.vue?vue&type=style&index=0&id=1c52a811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c52a811",
  null
  
)

export default component.exports